/**
 * Kiana Developers CRM - Mock Data & Navigation Configuration
 * Updated: 2026-05-14
 */

// --- USER & KPI DATA ---

export const currentUser = {
  id: 'u1',
  name: 'Aarav Sharma',
  email: 'aarav@kianadevelopers.com',
  role: 'Sales Manager',
  avatar: '',
};

export const kpis = [
  { label: 'Total Leads', value: 1284, delta: 12.4, icon: 'Users' },
  { label: 'Hot Prospects', value: 186, delta: 8.2, icon: 'Flame' },
  { label: 'Site Visits (MTD)', value: 74, delta: -3.1, icon: 'MapPin' },
  { label: 'Bookings (MTD)', value: 23, delta: 18.7, icon: 'KeyRound' },
  { label: 'Revenue (₹ Cr)', value: 14.8, delta: 22.5, icon: 'IndianRupee' },
  { label: 'Calls Today', value: 412, delta: 5.3, icon: 'PhoneCall' },
];

// --- NAVIGATION CONFIGURATION (Optimized Pipeline Flow) ---

export const navItems = [
  { label: 'Dashboard',    path: '/dashboard',   icon: 'LayoutDashboard', module: null },
  
  // Sales Pipeline
  { label: 'Leads',        path: '/leads',       icon: 'Users',           module: 'leads' },
  { label: 'Contacts',     path: '/contacts',    icon: 'Contact',         module: 'contacts' },
  { label: 'Calls',        path: '/calls',       icon: 'PhoneCall',       module: 'calls' }, // Moved here
  { label: 'Site Visits',  path: '/site-visits', icon: 'MapPin',          module: 'site_visits' },
  { label: 'Deals',        path: '/deals',       icon: 'Handshake',       module: 'deals' },
  { label: 'Bookings',     path: '/bookings',    icon: 'BookOpen',        module: 'bookings' },
  
  // Inventory & Daily Operations
  { label: 'Projects',     path: '/properties',  icon: 'Building2',       module: 'properties' },
  { label: 'Tasks',        path: '/tasks',       icon: 'ListChecks',      module: 'tasks' },
  
  // Finance & Legal
  { label: 'Payments',     path: '/payments',    icon: 'IndianRupee',     module: 'payments' },
  { label: 'Finance',      path: '/finance',     icon: 'Banknote',        module: 'finance' },
  { label: 'Registry',     path: '/registry',    icon: 'ScrollText',      module: 'registry' },
  
  // Administration & Insights
  { label: 'Reports',      path: '/reports',     icon: 'BarChart3',       module: 'reports' },
  { label: 'Admin',        path: '/admin',       icon: 'ShieldCheck',     module: 'admin' },
];

// --- ANALYTICS DATA ---

export const leadsBySource = [
  { source: 'Facebook Ads', count: 312, color: '#1B3A5C' },
  { source: 'Google Ads', count: 268, color: '#C8A464' },
  { source: 'Website', count: 214, color: '#3F6695' },
  { source: 'Referral', count: 178, color: '#8FA9C7' },
  { source: 'Walk-in', count: 142, color: '#E5C68A' },
  { source: 'Magicbricks', count: 96, color: '#5B7DA3' },
  { source: '99acres', count: 74, color: '#A88345' },
];

export const salesFunnel = [
  { stage: 'New', count: 1284, pct: 100 },
  { stage: 'Contacted', count: 842, pct: 66 },
  { stage: 'Qualified', count: 512, pct: 40 },
  { stage: 'Site Visit', count: 286, pct: 22 },
  { stage: 'Negotiation', count: 124, pct: 10 },
  { stage: 'Booked', count: 68, pct: 5 },
];

export const monthlyRevenue = [
  { m: 'Jan', revenue: 8.4, target: 10 },
  { m: 'Feb', revenue: 9.1, target: 10 },
  { m: 'Mar', revenue: 11.6, target: 11 },
  { m: 'Apr', revenue: 10.2, target: 11 },
  { m: 'May', revenue: 12.8, target: 12 },
  { m: 'Jun', revenue: 13.4, target: 12 },
  { m: 'Jul', revenue: 14.8, target: 13 },
];

// --- PROPERTY & INVENTORY DATA ---

export const properties = [
  {
    id: 'p1',
    name: 'SAI ADINATH MAJESTIC',
    type: '3BHK Apartments',
    status: 'Ready Possession',
    price: '₹95 L onwards',
    units: 48,
    sold: 31,
    location: 'Beedbypass Road, Chh. Sambhajinagar',
    area: '1,400 sq.ft',
    image: 'https://i.postimg.cc/rsm63k5D/unnamed.jpg',
  },
  {
    id: 'p2',
    name: 'MADHUBAN SQUARE',
    type: 'Residential & Commercial Plots',
    status: 'Ready To Build',
    price: '₹25 L onwards',
    units: 120,
    sold: 78,
    location: 'Gandheli, Chh. Sambhajinagar',
    area: '900 - 8,000 sq.ft',
    image: 'https://i.postimg.cc/DwxyXzL3/PRO-21-C1-copy-jpg.jpg',
  },
  {
    id: 'p3',
    name: 'SHANTI NAGAR PHASE-II',
    type: 'Bungalow Plots',
    status: 'Ready To Build',
    price: '₹60 L onwards',
    units: 64,
    sold: 22,
    location: 'Paithan Road, Chh. Sambhajinagar',
    area: '1,350 - 6,000 sq.ft',
    image: 'https://i.postimg.cc/02Xqh6zQ/01.jpg',
  },
  {
    id: 'p4',
    name: 'MADHUBAN HEIGHTS',
    type: '4 BHKD',
    status: 'Under Construction',
    price: '₹1.91 Cr onwards',
    units: 24,
    sold: 9,
    location: 'Mitra Nagar, Chh. Sambhajinagar',
    area: '1,800 sq.ft',
    image: 'https://i.postimg.cc/wjNtZd3D/Madhuban-Height-Building.png',
  },
  {
    id: 'p5',
    name: 'KRK GULMOHOR',
    type: 'Residential Plots',
    status: 'Ready To Build',
    price: '₹16.5 L onwards',
    units: 88,
    sold: 41,
    location: 'Patoda Road, Chh. Sambhajinagar',
    area: '651 - 1,060 sq.ft',
    image: 'https://i.ibb.co/MydPnBJz/KRK-cover.png',
  },
  {
    id: 'p6',
    name: 'ARAS VENTURES',
    type: '4BHK Ultra Luxury',
    status: 'Launching Soon',
    price: '₹1.95 Cr onwards',
    units: 18,
    sold: 0,
    location: 'Shivaji Nagar, Chh. Sambhajinagar',
    area: '1,500 sq.ft',
    image: 'https://i.postimg.cc/CxQnD7MS/aras-2.png',
  },
  {
    id: 'p7',
    name: 'LABH URBAN MEADOWS',
    type: 'Luxury Plots',
    status: 'Ready To Build',
    price: '₹55 L onwards',
    units: 96,
    sold: 12,
    location: 'Golwadi, Chh. Sambhajinagar',
    area: '1,200 - 6,000 sq.ft',
    image: 'https://i.postimg.cc/pTcwXNV7/med.png',
  },
];

// --- LEAD & CONTACT GENERATION ---

const firstNames = ['Rajesh','Priya','Amit','Sneha','Vikram','Neha','Rohit','Anjali','Suresh','Kavita','Arjun','Pooja','Manish','Divya','Kunal','Ritu','Sandeep','Megha','Akash','Shruti'];
const lastNames  = ['Patil','Deshmukh','Joshi','Kulkarni','Shinde','Pawar','Jadhav','Bhosale','Mehta','Shah','Iyer','Reddy','Gupta','Sharma','Verma','Nair','Khan','Sinha','Kapoor','Rao'];
const sources = ['Facebook Ads','Google Ads','Website','Referral','Walk-in','Magicbricks','99acres'];
const statuses = ['New','Contacted','Qualified','Site Visit','Negotiation','Booked','Lost'];
const priorities = ['Hot','Warm','Cold'];

function num(min,max){return Math.floor(Math.random()*(max-min+1))+min;}

export const leads = Array.from({length: 32}).map((_, i) => {
  const fn = firstNames[i % firstNames.length];
  const ln = lastNames[(i*3) % lastNames.length];
  const prop = properties[i % properties.length];
  return {
    id: 'L' + (1000 + i),
    name: `${fn} ${ln}`,
    email: `${fn.toLowerCase()}.${ln.toLowerCase()}@gmail.com`,
    phone: `+91 9${num(100000000,999999999)}`,
    source: sources[i % sources.length],
    status: statuses[i % (statuses.length - 1)],
    priority: priorities[i % priorities.length],
    property: prop.name,
    budget: `₹${num(25, 250)} L`,
    owner: ['Aarav Sharma','Riya Kapoor','Karan Mehta','Ishita Roy'][i % 4],
    createdAt: `2025-07-${String((i % 28) + 1).padStart(2,'0')}`,
    score: num(35, 98),
    notes: 'Looking for ready possession property near city centre.',
  };
});

export const contacts = leads.slice(0, 18).map(l => ({
  id: 'C' + l.id.slice(1),
  name: l.name,
  email: l.email,
  phone: l.phone,
  company: ['Self','Tata Consultancy','Infosys','Wipro','Reliance','HDFC','Self','ICICI'][Math.floor(Math.random()*8)],
  city: 'Chh. Sambhajinagar',
  tags: [l.priority, l.source],
  lastContact: l.createdAt,
}));

// --- DEALS, TASKS & ACTIVITY ---

export const deals = Array.from({length: 14}).map((_, i) => {
  const prop = properties[i % properties.length];
  const lead = leads[i];
  return {
    id: 'D' + (500 + i),
    title: `${prop.name} - ${lead.name}`,
    lead: lead.name,
    property: prop.name,
    value: num(2500000, 25000000),
    stage: ['Qualified','Site Visit','Negotiation','Booked'][i % 4],
    probability: [40, 60, 80, 100][i % 4],
    closeDate: `2025-0${(i%6)+1}-${String((i%28)+1).padStart(2,'0')}`,
    owner: lead.owner,
  };
});

export const tasks = [
  { id: 'T1', title: 'Follow up with Rajesh Patil', due: '2025-07-22 11:00', priority: 'High', status: 'Pending', owner: 'Aarav Sharma', related: 'L1000' },
  { id: 'T2', title: 'Send brochure - Madhuban Heights', due: '2025-07-22 14:30', priority: 'Medium', status: 'Pending', owner: 'Riya Kapoor', related: 'L1003' },
  { id: 'T3', title: 'Confirm site visit for Sneha Joshi', due: '2025-07-23 10:00', priority: 'High', status: 'In Progress', owner: 'Karan Mehta', related: 'L1004' },
  { id: 'T4', title: 'Negotiation call with Vikram Kulkarni', due: '2025-07-23 16:00', priority: 'High', status: 'Pending', owner: 'Aarav Sharma', related: 'L1005' },
  { id: 'T5', title: 'Prepare cost sheet - SAI ADINATH', due: '2025-07-24 09:00', priority: 'Medium', status: 'Pending', owner: 'Ishita Roy', related: 'L1006' },
  { id: 'T6', title: 'Update CRM after walk-in', due: '2025-07-21 18:00', priority: 'Low', status: 'Done', owner: 'Riya Kapoor', related: 'L1007' },
  { id: 'T7', title: 'Token amount collection - ARAS', due: '2025-07-25 12:00', priority: 'High', status: 'Pending', owner: 'Karan Mehta', related: 'L1008' },
  { id: 'T8', title: 'Schedule loan officer meeting', due: '2025-07-26 15:00', priority: 'Medium', status: 'Pending', owner: 'Aarav Sharma', related: 'L1009' },
];

export const teamPerformance = [
  { name: 'Aarav Sharma', leads: 86, calls: 142, visits: 18, bookings: 6, target: 8 },
  { name: 'Riya Kapoor',  leads: 72, calls: 168, visits: 14, bookings: 5, target: 8 },
  { name: 'Karan Mehta',  leads: 64, calls: 121, visits: 12, bookings: 4, target: 7 },
  { name: 'Ishita Roy',   leads: 58, calls: 109, visits: 10, bookings: 3, target: 6 },
  { name: 'Dev Khanna',   leads: 49, calls: 98,  visits: 8,  bookings: 2, target: 6 },
];

export const activities = [
  { type: 'lead', text: 'New lead Rajesh Patil from Facebook Ads', time: '2 min ago', icon: 'UserPlus' },
  { type: 'call', text: 'Call connected with Sneha Joshi (4:50)', time: '12 min ago', icon: 'PhoneCall' },
  { type: 'visit', text: 'Site visit scheduled - MADHUBAN HEIGHTS', time: '34 min ago', icon: 'MapPin' },
  { type: 'deal', text: 'Deal moved to Negotiation - Vikram K.', time: '1 hr ago', icon: 'TrendingUp' },
  { type: 'booking', text: 'Booking confirmed - SAI ADINATH (₹95 L)', time: '2 hr ago', icon: 'KeyRound' },
  { type: 'task', text: 'Riya Kapoor completed 4 follow-up tasks', time: '3 hr ago', icon: 'CheckCircle2' },
];